import { MapPin, BadgeCheck, Hammer } from "lucide-react";

const DEFAULT_ITEMS = [
  { icon: MapPin, label: "Sprawdzeni instalatorzy" },
  { icon: BadgeCheck, label: "Bezpłatna konsultacja" },
  { icon: Hammer, label: "Montaż nawet w 21 dni" },
];

export default function TrustStrip({ items = DEFAULT_ITEMS }) {
  const data = items;
  return (
    <section
      className="border-y border-brand-border bg-white"
      data-testid="trust-strip"
      aria-label="Zaufanie"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-6">
        <div className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-brand-ink">
          {data.map(({ icon: Icon, label }, i) => (
            <div key={label} className="flex items-center gap-2">
              <Icon className="h-4 w-4 text-brand-blue" strokeWidth={1.8} />
              <span className="text-sm sm:text-[0.95rem] font-medium">{label}</span>
              {i < data.length - 1 && (
                <span className="hidden sm:inline-block ml-5 h-1 w-1 rounded-full bg-brand-border" aria-hidden="true" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
